import { useQuery } from '@tanstack/react-query'
import { getOrganizations as getOrganizationsApi } from '../services/apiUsers.ts'

export interface Contact {
  id: number
  name: string
  address: string
  phone: string
  email: string
}

export function useOrganizations() {
  const {
    isLoading,
    data: allOrganizations,
    error,
  } = useQuery<Contact[], Error>({ queryKey: ['organizations'], queryFn: getOrganizationsApi })

  return { isLoading, allOrganizations, error }
}
